import { useState } from 'react';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { MODAL_SIZES, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import {
  CRITERIA_DESCRIPTION_MAX_LENGTH,
  MODAL_CONTENT,
} from 'modules/anonymousUserTracking/constants';
import { Button } from 'ui/button';
import { TextArea } from 'ui/inputs';
import { useEditCriteriaDescription } from 'modules/anonymousUserTracking/hooks/useEditCriteriaDescription';
import { ModalHeaderWrapper } from '../AnonymousUserTracking.styled';

const { EDIT_DESCRIPTION_HEADER, EDIT_DESCRIPTION_BUTTON_LABEL } = MODAL_CONTENT;
export const EditDescriptionModal = ({
  onClose,
  criteria,
}: {
  onClose: () => void;
  criteria: AnonUserCriteria;
}) => {
  const { editCriteriaDescription } = useEditCriteriaDescription(criteria);
  const [description, setDescription] = useState(criteria.fields.description ?? '');

  const handleUpdateDescription = () => {
    editCriteriaDescription(description);
    onClose();
  };

  return (
    <Modal
      id="edit-criteria-description-modal"
      isModalOpen
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>
        <ModalHeaderWrapper>{EDIT_DESCRIPTION_HEADER}</ModalHeaderWrapper>
      </ModalHeader>
      <ModalBody>
        <TextArea
          value={description}
          onChange={setDescription}
          maxLength={CRITERIA_DESCRIPTION_MAX_LENGTH}
          isCharacterCountShown
          isCharacterCountTemporarilyVisible
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleUpdateDescription}>{EDIT_DESCRIPTION_BUTTON_LABEL}</Button>
      </ModalFooter>
    </Modal>
  );
};
